import React from 'react'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Paper from 'material-ui/Paper'

const NoAccess = ({
  title = '',
  subtitle = '',
  admins = [],
  icon = 'security',
  style = {}
}) => {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div style={{ ...{ textAlign: 'center' }, ...style }}>
        <Paper style={{ padding: 15, color: '#555' }}>
          <Icon style={{ fontSize: 120, margin: 15 }}>{icon}</Icon>
          <Typography type="title" style={{ margin: 25 }}>
            {title.toUpperCase()}
          </Typography>
          <Typography type="subheading">{subtitle.toUpperCase()}</Typography>
          <div style={{ margin: 20 }}>
            {admins.map((a, i) => (
              <div key={`NoAccess-${i}`}>
                <Button raised color="primary" href={`/${a.toLowerCase()}`}>
                  {a}
                </Button>
              </div>
            ))}
          </div>
        </Paper>
      </div>
    </div>
  )
}

export default NoAccess



// WEBPACK FOOTER //
// ./src/core/components/NoAccess.js